import z from "zod";

// Register schema
const RegisterSchema = z.object({
  username: z.string().min(3, "Username must be at least 3 characters"),
  name: z.string().min(2, "Name must be at least 2 characters"),
  phoneNumber: z.string().min(10, "Please enter a valid phone number"),
  email: z.string().email("Please enter a valid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
  role: z.enum(["ADMIN", "MERCHANT"]),
});

// Login schema
const LoginSchema = z.object({
  username: z.string().min(3, "Username must be at least 3 characters"),
  password: z.string().min(6, "Password must be at least 6 characters"),
  rememberMe: z.boolean().optional().default(false),
});

// Change password schema
const ChangePasswordSchema = z
  .object({
    currentPassword: z
      .string()
      .min(6, "Old password must be at least 6 characters"),
    newPassword: z
      .string()
      .min(6, "New password must be at least 6 characters"),
    confirmationPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmationPassword, {
    message: "Passwords don't match",
    path: ["confirmationPassword"],
  });

export { ChangePasswordSchema, LoginSchema, RegisterSchema };
